module.exports = __webpack_public_path__ + "static_wap/img/meiyoushoucang.0f2b949.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/meiyoushoucang.png
// module id = /ji9
// module chunks = 1